<template>
  <AdminSectionContainer>
    <h2>Add New Source</h2>
    <v-card
      elevation="2"
      class="pa-3 my-3"
    >
      <v-select
        solo
        flat
        hide-details
        class="ma-0 pa-0"
        style="height: 40px;"
        v-model="type"
        :items="items"
        label="Type de source"
      />
      <v-divider class="my-2" />
      <v-col v-if="type === SourceType.RssFeed">
        <v-text-field
          v-model="rssType.title"
          label="Title"
          class="form-text-field"
          :rules="rulesTitle"
          hide-details="auto"
        />
        <v-text-field
          v-model="rssType.domain"
          label="Domain"
          class="form-text-field"
          :rules="rulesDomain"
          hide-details="auto"
        />
        <v-text-field
          v-model="rssType.rssUrl"
          label="RssUrl"
          class="form-text-field"
          :rules="rulesRssUrl"
          hide-details="auto"
        />
        <v-switch
          hide-details
          v-model="rssType.active"
          :label="(rssType.active) ? 'Active': 'Inactive'"
        />
        <div class="d-flex justify-end">
          <v-btn
            outlined
            color="primary"
            :disabled="!validRssTypeForm()"
            @click.exact.stop="saveRssTypeSource"
          >
            Save
          </v-btn>
        </div>
      </v-col>
      <v-col v-if="type === SourceType.Keywords">
        <v-text-field
          v-model="keywordsType.title"
          label="Titre"
          class="form-text-field"
          :rules="rulesTitle"
          hide-details="auto"
        />
        <v-text-field
          v-model="keywordsType.keywords"
          label="Mots clés"
          class="form-text-field"
          :rules="rulesKeywords"
          @input="updateRssUrl"
          hide-details="auto"
        />
        <v-select
          hide-details
          class="form-text-field mb-3"
          v-model="keywordsType.language"
          :items="languages"
          @input="updateRssUrl"
          label="Type de source"
        />
        <v-switch
          hide-details
          class="ma-0"
          v-model="keywordsType.active"
          :label="(keywordsType.active) ? 'Source Activée': 'Source Déactivée'"
        />
        <v-divider class="my-2 mt-4" />
        <div class="mt-2">
          <span class="mr-2">
            Domaine:
          </span>
          <a
            class="clickable-url"
            :href="keywordsType.domain"
          >
            {{ keywordsType.domain }}
          </a>
        </div>
        <div class="mt-2">
          <span class="mr-2">
            Rss Source:
          </span>
          <a
            class="clickable-url"
            :href="keywordsType.rssUrl"
          >
            {{ keywordsType.rssUrl }}
          </a>
        </div>
        <div class="d-flex justify-end">
          <v-btn
            outlined
            color="primary"
            :disabled="!validKeywordsTypeForm()"
            @click.exact.stop="saveKeywordTypeSource"
          >
            Save
          </v-btn>
        </div>
      </v-col>
    </v-card>
    <div>
      <h3 class="my-3" style="font-weight: 500;">
        Your Sources
      </h3>
      <v-card
        elevation="2"
        class="pa-3 my-3"
      >
        <div class="scrollbar">
          <div
            v-for="source in userSources"
            :key="source.id"
          >
            <v-card
              outlined
              elevation="1"
              class="pa-2 d-flex align-center"
            >
              <v-icon :color="(source.active) ? 'green' : 'grey'">
                circle
              </v-icon>
              <span class="ml-2 text-ellipsis source-title">
                {{ source.title }}
              </span>
              <span class="ml-2 text-ellipsis source-domain">
                {{ source.rssUrl }}
              </span>
              <v-spacer />
              <v-icon
                @click.stop.prevent="fillSourceForm(source)"
                class="ml-2"
              >
                edit
              </v-icon>
            </v-card>
          </div>
        </div>
      </v-card>
    </div>
  </AdminSectionContainer>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { types } from '@/store/rootTypes';
import AdminSectionContainer from './AdminSectionContainer';

const SourceType = {
  RssFeed: 'Rss Feed',
  Keywords: 'Keywords (with Google News)',
};
const Language = {
  Fr: 'French',
  EnUs: 'English US',
  EnCa: 'English CA',
};
export default {
  name: 'RssSource',
  components: { AdminSectionContainer },
  data() {
    return {
      SourceType,
      languages: [Language.Fr, Language.EnUs, Language.EnCa],
      rssType: {
        title: '',
        domain: '',
        rssUrl: '',
        active: true,
      },
      keywordsType: {
        title: '',
        domain: 'https://news.google.com',
        rssUrl: 'https://news.google.com/rss/search',
        keywords: '',
        active: true,
        language: Language.Fr,
      },
      type: SourceType.RssFeed,
      items: [SourceType.RssFeed, SourceType.Keywords],
      rulesTitle: [this.validTitle],
      rulesDomain: [this.validDomain],
      rulesRssUrl: [this.validRssUrl],
      rulesKeywords: [this.validKeywords],
    };
  },
  computed: {
    ...mapGetters({
      userSources: types.sources.getters.userSources,
    }),
  },
  methods: {
    ...mapActions({
      saveUserSource: types.sources.actions.saveUserSource,
      fetchUserSources: types.sources.actions.fetchUserSources,
    }),
    updateRssUrl() {
      const languageRegion = this.determineLanguageRegion();

      const query = encodeURI(this.keywordsType.keywords)
        .toString()
        .replace(/&/g, '%26');
      this.keywordsType.rssUrl = encodeURI(`${this.keywordsType.domain}/rss/search?${languageRegion}`)
        .toString()
        .concat(`&q=${query}`)
        .toString();
    },
    determineLanguageRegion() {
      if (this.keywordsType.language === Language.Fr) {
        return 'gl=CA&hl=fr-CA&ceid=CA:fr';
      }
      if (this.keywordsType.language === Language.EnUs) {
        return 'hl=en-US&gl=US&ceid=US:en';
      }
      if (this.keywordsType.language === Language.EnCa) {
        return 'hl=en-CA&gl=CA&ceid=CA:en';
      }
      throw Error('Language not supported');
    },
    validTitle(value) {
      if (!value) return false;

      return value.length >= 3;
    },
    validKeywords(value) {
      if (!value) return false;

      return value.length >= 3;
    },
    validDomain(value) {
      if (!value) return false;

      return this.validURL(value);
    },
    validRssUrl(value) {
      if (!value) return false;

      return this.validURL(value);
    },
    validURL(value) {
      try {
        const url = new URL(value);
        if (!url) return false;

        return true;
      } catch (error) {
        return false;
      }
    },
    validRssTypeForm() {
      return this.validTitle(this.rssType.title)
        && this.validDomain(this.rssType.domain)
        && this.validRssUrl(this.rssType.rssUrl);
    },
    validKeywordsTypeForm() {
      return this.validTitle(this.keywordsType.title)
        && this.validDomain(this.keywordsType.domain)
        && this.validKeywords(this.keywordsType.keywords);
    },
    saveKeywordTypeSource() {
      const source = {
        title: this.keywordsType.title,
        domain: this.keywordsType.domain,
        rssUrl: this.keywordsType.rssUrl,
        active: this.keywordsType.active,
        keywords: this.keywordsType.keywords,
        language: this.keywordsType.language,
        type: 'RssFeed',
        subtype: 'Keywords',
      };
      this.saveUserSource(source);
    },
    saveRssTypeSource() {
      this.saveUserSource({
        type: 'RssFeed',
        ...this.rssType,
      });
    },
    fillSourceForm(source) {
      if (source.subtype === 'Keywords') {
        this.type = SourceType.Keywords;
        this.keywordsType = {
          title: source.title,
          domain: source.domain,
          rssUrl: source.rssUrl,
          keywords: source.keywords,
          active: source.active,
          language: source.language,
        };
        return;
      }
      this.type = SourceType.RssFeed;
      this.rssType = {
        title: source.title,
        domain: source.domain,
        rssUrl: source.rssUrl,
        active: source.active,
      };
    },
  },
  created() {
    this.fetchUserSources();
  },
};
</script>
<style scoped>
.form-text-field {
  min-width: 400px;
}
.clickable-url {
  font-size: 14px;
  font-weight: 300;
}
.clickable-url:hover {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}
.source-title {
  max-width: 50%;
  font-size: 16px;
  font-weight: 500;
}
.source-domain {
  font-size: 12px;
}
.text-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/* SCROLLBAR CSS */
.scrollbar {
  overflow-y: auto;
  max-height: 500px;
  margin: 6px;
  padding: 6px;
}
::-webkit-scrollbar {
  width: 12px;
}
::-webkit-scrollbar-track {
  border-radius: 6px;
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #c1c1c1;
}
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
